export var toUrlSlug = function (input, allowTrailingHyphen) {
    return input
        .replace(/'/g, '') // Remove apostrophes
        .replace(/[^a-zA-Z0-9\u00C0-\u00FF]/g, '-') // Replace non-Latin and non-alphanumeric with hyphens
        .replace(/-+/g, '-') // Collapse multiple hyphens
        .replace(/-$/, allowTrailingHyphen ? '-' : '') // Remove trailing hyphen
        .replace(/^-/, '') // Remove leading hyphen
        .toLowerCase();
};
